// Artist Marketing view
// Same as provider, separation for route redirection / clarity

import React from 'react';
import useScreenViewEvent from '@deezer/next/shared/hooks/useScreenViewEvent';
import {ScreenViewName} from '@deezer/next/services/tracking/LogCenter/events/types';

import NavigationLayout from '@deezer/next/shared/layouts/NavigationLayout';
import {FeatureLabel} from '@deezer/next/services/types/features';
import {getServerSideTranslationsWrapper} from '@deezer/next/shared/utils/next';
import ProviderOverview from '@deezer/next/features/Analytic/screens/ProviderOverview';

const View = () => {
	useScreenViewEvent(
		() => ({
			screenName: ScreenViewName.OVERVIEW,
		}),
		[],
	);

	return <ProviderOverview />;
};

View.getLayout = (page: React.ReactElement) => {
	return <NavigationLayout>{page}</NavigationLayout>;
};

export const getStaticProps = getServerSideTranslationsWrapper(() => {
	return {
		props: {
			logged: true,
			mode: 'light',
			right: FeatureLabel.ANALYTICS_VIEWER,
		},
	};
});

export default View;
